import React, {forwardRef, useImperativeHandle, useMemo} from "react";
import {Checkbox, CheckboxProps, Col} from "antd";
import {GetSectorsAPIParams, SectorTypeV2} from "../../../api/apiTypes";
import {CheckboxGroupProps} from "antd/es/checkbox";
import Lottie from "lottie-react";
import spinner from "../../../assets/lotties/spinner.json";
import {queries} from "../../../api/queries";
import {useTranslation} from "react-i18next";
import useSWR from "swr";
import {fetcher} from "../../../services/http.service";
import {objToQueryString, removeExistingParamsArrayValue} from "../../../common/fns";
import {useSearchParams} from "react-router-dom";

interface Props extends CheckboxGroupProps {
  params: GetSectorsAPIParams;
}

const SectorFilter = forwardRef(({params, value}: Props, ref) => {
  const {t} = useTranslation(["shipping"]);
  const [_, setSearchParams] = useSearchParams();
  const paramString = useMemo(() => {
    if (!params) {
      params = {};
    }
    const {
            designated_sector__code__in, ...filtered
          } = params;
    return objToQueryString(filtered, true);
  }, [params]);
  
  const {
          data: sectors, isLoading, mutate
        } = useSWR<SectorTypeV2[]>(queries.shipping.sectors + `?${paramString}`, fetcher);
  
  console.log("SectorFilter params:", value, params, sectors);
  const allCode = useMemo(() => {
    if (sectors && sectors.length) {
      return sectors.map(({designated_sector__code}) => designated_sector__code);
    }
    return [];
  }, [sectors]);
  
  const checkAll = value && sectors && sectors.length === value.length;
  
  useImperativeHandle(ref, () => ({
    mutate,
  }), []);
  
  const handleCheckAll: CheckboxProps['onChange'] = (e) => {
    if (e.target.checked) {
      setSearchParams((prev) => ({
        ...removeExistingParamsArrayValue(prev, "designated_sector__code__in", allCode),
        designated_sector__code__in: allCode
      }));
    }
    else {
      setSearchParams((prev) => ({
        ...removeExistingParamsArrayValue(prev, "designated_sector__code__in", value),
        designated_sector__code__in: []
      }));
    }
  };
  
  const handleChangeChecked = (checkedValues: any[]) => {
    console.log("checked = ", checkedValues);
    setSearchParams((prev) => ({
      ...removeExistingParamsArrayValue(prev, "designated_sector__code__in", checkedValues),
      designated_sector__code__in: checkedValues
    }));
  };
  
  return (<div className={"column"}>
    <div className={"title"}>
      <span>{t("sector code")}</span>
      <Checkbox className={"checkAll"} onChange={handleCheckAll}
                checked={checkAll}>
        전체
      </Checkbox>
    </div>
    <Checkbox.Group
      className={"wrapper-rd-wh-sm check"}
      value={value}
      onChange={handleChangeChecked}
    >
      <Col>
        {sectors && sectors.length ? sectors.map((s, idx) => (<Checkbox
          key={"check" + idx}
          className={"item"}
          data-cy="homeManageCheckbox"
          value={s.designated_sector__code}
        >
          {`${s.designated_sector__code}(${s.count})`}
        </Checkbox>)) : (isLoading ? <Lottie autoplay animationData={spinner} loop style={{height: 25}} /> : <span
          className={"nodata"}>데이터가 없습니다</span>)}
      </Col>
    </Checkbox.Group>
  </div>);
});

export default SectorFilter;
